import { NavigationContainer } from '@react-navigation/native';
import { StatusBar } from 'expo-status-bar';
import { StyleSheet, Text, View } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import Login from './screens/Login';
import Home from './screens/Home';
import Answers from './screens/Answers';
import Points from './screens/Points';
import AdminLayout from './layout/Admin';
import Categories from './screens/Categories';
import AddEditCategory from './screens/AddEditCategory';
import Songs from './screens/Songs';
import AddEditSong from './screens/AddEditSong';
import Settings from './screens/Settings';
import Display from './screens/Display';

const Stack = createNativeStackNavigator();

export default function App() {
  return (
    <NavigationContainer linking>
      <Stack.Navigator initialRouteName="Login">
        <Stack.Screen name="Login" component={Login} options={{ title: 'Login' }} />
        <Stack.Screen name="Home" options={{ title: 'Home' }} key={'Home'}>
          {props => (
            <AdminLayout {...props}>
              <Home {...props} />
            </AdminLayout>
          )}
        </Stack.Screen>
        <Stack.Screen name="Categories" options={{ title: 'Categories' }} key={'Categories'}>
          {props => (
            <AdminLayout {...props}>
              <Categories {...props} />
            </AdminLayout>
          )}
        </Stack.Screen>
        <Stack.Screen name="AddEditCategory" options={{ title: 'AddEditCategory' }} key={'AddEditCategory'}>
          {props => (
            <AdminLayout {...props}>
              <AddEditCategory {...props} />
            </AdminLayout>
          )}
        </Stack.Screen>
        <Stack.Screen name="Songs" options={{ title: 'Songs' }} key={'Songs'}>
          {props => (
            <AdminLayout {...props}>
              <Songs {...props} />
            </AdminLayout>
          )}
        </Stack.Screen>
        <Stack.Screen name="AddEditSong" options={{ title: 'AddEditSong' }} key={'AddEditSong'}>
          {props => (
            <AdminLayout {...props}>
              <AddEditSong {...props} />
            </AdminLayout>
          )}
        </Stack.Screen>
        <Stack.Screen name="Settings" options={{ title: 'Settings' }} key={'Settings'}>
          {props => (
            <AdminLayout {...props}>
              <Settings {...props} />
            </AdminLayout>
          )}
        </Stack.Screen>
        <Stack.Screen name="Answers" options={{ title: 'Answers', headerShown: false }} key={'Answers'}>
          {props => (
            // <AdminLayout {...props}>
              <Answers {...props} />
            // </AdminLayout>
          )}
        </Stack.Screen>
        <Stack.Screen name="Points" options={{ title: 'Points', headerShown: false }} key={'Points'}>
          {props => (
            // <AdminLayout {...props}>
              <Points {...props} />
            // </AdminLayout>
          )}
        </Stack.Screen>
        <Stack.Screen name="Display" options={{ title: 'Display', headerShown: false }} key={'Display'}>
          {props => (
            <Display {...props} />
          )}
        </Stack.Screen>
      </Stack.Navigator>
    </NavigationContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
